// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"315":"fe86bc14","787":"844dbe7a","789":"aaedc91f","923":"f5e2b0bd"}[chunkId] + ".chunk.js";
};